"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileList = void 0;
var React = require("react");
var memoize = require("fast-memoize");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var TypesLib = require("@caddigital/sok-types");
var recompose_1 = require("recompose");
require("./index.scss");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var filesMemoize_1 = require("utils/helpers/filesMemoize");
var text_1 = require("utils/text");
var utils_1 = require("./utils");
var automaticFileConversion_1 = require("utils/dispatchers/automaticFileConversion");
var react_redux_1 = require("react-redux");
function lookupFromArray(a) {
    var lookup = {};
    for (var i = 0; i < a.length; i++) {
        lookup[a[i].uuid] = true;
    }
    return lookup;
}
var generateMetaLookup = memoize(function (columns) {
    var widths = {};
    var metaLookup = new Map();
    columns.forEach(function (curr) {
        if (curr.id === undefined ||
            curr.hideOnFileList ||
            (curr.bitField & TypesLib.CustomMeta.FILES_LIST) === 0 ||
            (curr.bitField & TypesLib.CustomMeta.HIDE_ON_FILES_LIST) > 0) {
            return;
        }
        var dataKey = '__' + curr.id;
        var text = (0, translation_1.getLocalization)(curr.name.toString()).toString();
        var length = (0, text_1.calculateStringLength)(text) + 42;
        widths[dataKey] = { text: text, length: length };
        metaLookup.set(curr.id.toString(), curr);
    });
    return { columnMap: metaLookup, columns: widths };
});
var getMode = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    return ((_a = props.searchOptions) === null || _a === void 0 ? void 0 : _a.searchString) !== '' ||
        ((_b = props.searchOptions) === null || _b === void 0 ? void 0 : _b.containsTermString) !== '' ||
        ((_c = props.searchOptions) === null || _c === void 0 ? void 0 : _c.searchFileType.isSome()) ||
        ((_d = props.searchOptions) === null || _d === void 0 ? void 0 : _d.toggleRecents) === true ||
        ((_e = props.searchOptions) === null || _e === void 0 ? void 0 : _e.filtering) !== 'NONE' ||
        ((_f = props.searchOptions) === null || _f === void 0 ? void 0 : _f.from) !== null ||
        ((_g = props.searchOptions) === null || _g === void 0 ? void 0 : _g.to) !== null
        ? 'SEARCH'
        : 'NORMAL';
};
var updateItems = function (props, nextProps) {
    var mode = getMode(props);
    var lookup = generateMetaLookup(nextProps.metaDataColumns);
    var columnMap = lookup.columnMap, columns = lookup.columns;
    var cols = __assign({}, columns);
    nextProps.items.forEach(function (x) {
        columnMap.forEach(function (value, key) {
            if (x.customMeta[key]) {
                var dataKey = '__' + key;
                var text = '';
                var data = value;
                if (data.type === 'select') {
                    var o = void 0;
                    if (data.options) {
                        o = data.options.find(function (o) {
                            return o.value === x.customMeta[key];
                        });
                    }
                    text = o ? o.name : '';
                }
                else {
                    text = x.customMeta[key].toString();
                }
                var length = (0, text_1.calculateStringLength)(text) + 42;
                if (cols[dataKey] && cols[dataKey].length < length) {
                    cols[dataKey] = { text: text, length: length };
                }
            }
        });
    });
    var lengths = Object.keys(cols).reduce(function (prev, x) {
        prev[x] = cols[x].length;
        return prev;
    }, {});
    // Override styles for dynamic classes
    var style = document.getElementById('FilesListCSS' + props.parentClass ? "_".concat(props.parentClass) : '');
    if (style && style.parentNode) {
        style.parentNode.removeChild(style);
    }
    style = document.createElement('style');
    style.id = 'FilesListCSS' + props.parentClass ? "_".concat(props.parentClass) : '';
    document.head && document.head.appendChild(style);
    var sheet = style.sheet;
    var staticIconCount = nextProps.staticIconCount !== undefined ? nextProps.staticIconCount : 6;
    var contentWidth = (0, utils_1.calculateContentWidth)({
        staticIcons: staticIconCount,
        columns: lengths,
        extraWidth: mode === 'SEARCH' ? 40 : 0,
        viewportSize: nextProps.viewportSize,
        onColumnWidthCalc: function (_a) {
            var columnKey = _a.columnKey, columnWidth = _a.columnWidth, columnIndex = _a.columnIndex;
            return sheet.insertRule("".concat(props.parentClass ? '.' + props.parentClass : '', " .").concat(columnKey) +
                ' {max-width: ' +
                columnWidth +
                'px;\n min-width: ' +
                columnWidth +
                'px;}', columnIndex);
        }
    });
    nextProps.setContentWidth(contentWidth);
    nextProps.setColumns(lookup);
};
var noSelectedColumnsAnnouncement = function () {
    var title = (0, translation_1.getLocalization)('fileslist/search/noFiles/dearSokoproUser');
    var body = (0, translation_1.getLocalization)('fileslist/search/noFiles/noSelectedColumns');
    var hint = (0, translation_1.getLocalization)('fileslist/search/noFiles/trySelectingColumns');
    return React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { title: title, message: body, message2: hint });
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('element', 'setElement', null), (0, recompose_1.withState)('columns', 'setColumns', null), (0, recompose_1.withState)('itemSelectionsLookup', 'setItemSelectionsLookup', {}), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var arrayLookup = lookupFromArray(this.props.itemSelections);
        this.props.setItemSelectionsLookup(arrayLookup);
        var props = this.props;
        if (props.metaDataColumns.length > 0 && props.items.length > 0) {
            updateItems(props, props);
        }
    },
    componentWillReceiveProps: function (nextProps) {
        var props = this.props;
        if (nextProps.metaDataColumns !== this.props.metaDataColumns ||
            nextProps.items !== this.props.items ||
            nextProps.isMobile !== this.props.isMobile) {
            updateItems(props, nextProps);
        }
        if (nextProps.itemSelections !== props.itemSelections) {
            var arrayLookup = lookupFromArray(nextProps.itemSelections);
            nextProps.setItemSelectionsLookup(arrayLookup);
        }
    }
}), (0, recompose_1.shouldUpdate)(function (nextProps, props) {
    return nextProps.items !== props.items ||
        nextProps.contentWidth !== props.contentWidth ||
        (0, List_1.shallowDiffers)(nextProps.sortByOptions, props.sortByOptions) ||
        nextProps.columns !== props.columns ||
        nextProps.itemSelectionsLookup !== props.itemSelectionsLookup ||
        nextProps.isMobile !== props.isMobile ||
        nextProps.metaDataColumns !== props.metaDataColumns;
}));
// Helper function memoizes props to avoid unnecessary re-renders of Row component.
var createRowData = memoize(function (columns, downloadFolder, convert, openNotificationsSideMenu, navigateTo, toggleItem, onBookmark, onUnBookmark, token, items, isMobile, mode, baseUrl, itemSelections, hideActions, hideDownload, metaDataColumns, perm) { return ({
    isMobile: isMobile,
    mode: mode,
    items: items,
    columns: columns,
    baseUrl: baseUrl,
    itemSelections: itemSelections,
    downloadFolder: downloadFolder,
    convert: convert,
    openNotificationsSideMenu: openNotificationsSideMenu,
    navigateTo: navigateTo,
    toggleItem: toggleItem,
    onBookmark: onBookmark,
    onUnBookmark: onUnBookmark,
    token: token,
    hideActions: hideActions,
    hideDownload: hideDownload,
    metaDataColumns: metaDataColumns,
    perm: perm
}); }, filesMemoize_1.memoizeSerializer);
exports.FileList = enhance(function (props) {
    var dispatchProps = (0, automaticFileConversion_1.mapDispatchToProps)((0, react_redux_1.useDispatch)());
    var mergedProps = React.useMemo(function () { return (__assign(__assign({}, dispatchProps), props)); }, [props]);
    var _a = (0, react_redux_1.useSelector)(function (state) { return ({
        automaticFileConversion: state.files.automaticFileConversion,
        automaticFileConversionError: state.files.automaticFileConversion.error
    }); }), automaticFileConversion = _a.automaticFileConversion, automaticFileConversionError = _a.automaticFileConversionError;
    React.useEffect(function () {
        if (automaticFileConversionError) {
            var file = props.items.find(function (file) { return file.uuid === automaticFileConversion.revisionUuid; });
            mergedProps.setFilePreview('none', automaticFileConversion.revisionUuid, 'FAILED');
            if (file)
                mergedProps.setConversionErrorToast(file.name, automaticFileConversionError);
        }
        else if (automaticFileConversion.preview.uuid)
            mergedProps.setFilePreview(automaticFileConversion.preview.uuid, automaticFileConversion.revisionUuid, automaticFileConversion.preview.status);
    }, [automaticFileConversion, automaticFileConversionError]);
    React.useEffect(function () {
        mergedProps.clearAutomaticConversionStatus();
        return mergedProps.clearAutomaticConversionStatus;
    }, []);
    if (!props.columns || props.columns.columnMap.size === 0) {
        return noSelectedColumnsAnnouncement();
    }
    var projectSchema = Array.from(props.columns.columnMap.values());
    var mode = getMode(props);
    // memoize item props into props.data object
    var itemData = createRowData(props.columns, props.downloadFolder, props.convert, props.openNotificationsMenu, props.navigateTo, props.toggleItem, props.onBookmarkClick, props.onUnBookmarkClick, props.token, props.items, props.isMobile, mode, props.baseUrl, props.itemSelectionsLookup, props.hideActions || false, props.hideDownload || false, props.metaDataColumns, props.perm);
    return (React.createElement("div", { ref: props.setElement, className: 'files-view-list-container' },
        React.createElement("div", { className: 'files-view-list' },
            React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: Math.min((props.items.length + 1) * 50, height), itemHeight: 50, viewportSize: props.viewportSize, itemWidth: props.contentWidth, header: React.createElement(props.ListHeader, { mode: mode, currentFolder: props.currentFolder, projectSchema: projectSchema, isAllSelected: props.isAllSelected, isAllBookmarked: props.isAllBookmarked, isAllFollowed: props.isAllFollowed, sortByOptions: props.sortByOptions, searchOptions: props.searchOptions, onSelectAll: props.onSelectAll, onBookmarkAll: props.onBookmarkAllFiles, onSetColumnFilter: props.onSetColumnFilter, openNotificationsMenu: props.openNotificationsMenu, downloadFolder: props.downloadFolder, sortBy: props.sortBy, hideActions: props.hideActions || false, hideDownload: props.hideDownload || props.hideHeaderDownload || false }) }, props.ListRow));
            }))));
});
